@if (wizardType === WizardType.DIGITAL_SIGNATURE && currentStep === 0) {
  <div class="flex pr-4 portrait:mt-2 w-full justify-end">
    <button
      class="text-white text-sm rounded-full py-2 px-2 h-[40px] w-[150px]"
      [ngClass]="
            brand.isLexus()
              ? 'bg-lexusBlue hover:bg-lexusBlueDark'
              : 'bg-toyotaRed hover:bg-toyotaRedDark'
      "
      (click)="nextStep.emit()"
    >
      Starten
    </button>
  </div>
}

@if (showActionButtons) {
  <div>
    @if (wizardType === WizardType.EWE_BY_EMAIL) {
      <div class="flex w-full justify-between bg-white py-2 gap-1">
        <button
          class="text-sm rounded-full py-2 px-2 h-[40px] w-[40px] bg-buttonsBar hover:bg-[#b8b9ba]"
          (click)="previousStep.emit()"
        >
          <img src="assets/icons/back.png" class="w-25 h-25 sm:w-35 sm:h-35">
        </button>

        <div class="flex items-center gap-1 sm:gap-2 md:gap-4">
          <button
            class="rounded-full text-sm leading-[14px] border-2 border-black px-2 h-[40px] min-w-[120px] sm:min-w-[150px] items-center underline hover:bg-gray-100"
            (click)="skip.emit()"
          >
            @if (skipAllInProgress) {
              <app-activity-spinner />
            }
            Überspringen
          </button>

          <button
            class="text-white text-sm rounded-full py-2 px-2 h-[40px] w-[120px] sm:w-[150px]"
            [ngClass]="
            brand.isLexus()
            ? 'bg-lexusBlue hover:bg-lexusBlueDark'
            : 'bg-toyotaRed hover:bg-toyotaRedDark'
            "
            (click)="accept.emit()"
          >
            Einwilligen
          </button>
        </div>
      </div>
    }

    @if (wizardType === WizardType.DIGITAL_SIGNATURE) {
      <div class="flex justify-between items-end portrait:pr-0 md:portrait:pr-4 landscape:pr-4 w-full gap-2">
        <!-- tablet and desktop -->
        <button
          class="portrait:hidden md:portrait:block landscape:block text-sm rounded-full py-2 px-2 h-[40px] w-[100px] lg:w-[120px] xl:w-[150px] bg-buttonsBar hover:bg-[#b8b9ba]"
          (click)="previousStep.emit()"
        >
          Zurück
        </button>

        <!-- tablet and desktop -->
        <button
          class="portrait:hidden md:portrait:block landscape:block text-sm rounded-full py-2 px-2 h-[40px] min-w-[100px] lg:min-w-[120px] xl:min-w-[150px] items-center bg-toyotaGreyLight text-white hover:bg-[#78797d]"
          (click)="skip.emit()"
        >
          @if (skipAllInProgress) {
            <app-activity-spinner />
          }
          Überspringen
        </button>

        <app-signature
          #sig
          [city]="customerWizardResponse.dealer.city"
          class="landscape:w-[55%] portrait:w-[70%] md:portrait:w-[55%]"
        />

        <!--tablet and desktop-->
        <button
          class="portrait:hidden md:portrait:block landscape:block text-white text-sm rounded-full py-2 px-2 h-[40px] w-[100px] lg:min-w-[120px] xl:min-w-[150px] disabled:opacity-40 disabled:cursor-not-allowed"
          [disabled]="!sig.touched"
          [ngClass]="
              brand.isLexus()
              ? 'bg-lexusBlue hover:bg-lexusBlueDark'
              : 'bg-toyotaRed hover:bg-toyotaRedDark'
              "
          (click)="accept.emit(sig.getDataURL())"
        >
          {{ currentStep === 3 ? 'Absenden' : 'Weiter' }}
        </button>

        <!-- mobile -->
        <div class="landscape:hidden portrait:block md:portrait:hidden w-[100px] flex flex-col items-center">
          <button
            class="text-sm rounded-full py-2 px-2 h-[40px] w-[100px] lg:w-[120px] xl:w-[150px] bg-buttonsBar hover:bg-[#b8b9ba]"
            (click)="previousStep.emit()"
          >
            Zurück
          </button>

          <button
            class="text-sm rounded-full py-2 px-2 h-[40px] min-w-[100px] lg:min-w-[120px] xl:min-w-[150px] items-center bg-toyotaGreyLight text-white hover:bg-[#78797d] mt-2"
            (click)="skip.emit()"
          >
            @if (skipAllInProgress) {
              <app-activity-spinner />
            }
            Überspringen
          </button>

          <button
            class="text-white text-sm rounded-full py-2 px-2 h-[40px] w-[100px] lg:min-w-[120px] xl:min-w-[150px] disabled:opacity-40 disabled:cursor-not-allowed mt-2"
            [disabled]="!sig.touched"
            [ngClass]="
              brand.isLexus()
              ? 'bg-lexusBlue hover:bg-lexusBlueDark'
              : 'bg-toyotaRed hover:bg-toyotaRedDark'
              "
            (click)="accept.emit(sig.getDataURL())"
          >
            {{ currentStep === 3 ? 'Absenden' : 'Weiter' }}
          </button>
        </div>
      </div>
    }
  </div>
}
